import {Observable} from 'rxjs';
import {share, mergeMap, exhaustMap, takeWhile, take, map, skipWhile, catchError} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import * as Api from './api';
import * as Actions from './actions';

const POLL_INTERVAL_MS = 1000;
const MAX_POLL_ATTEMPTS = 120;

const generateAsyncLink = action$ =>
    action$.ofType(Actions.generateAsyncLink.type).mergeMap(({payload}) =>
        Api.generateAsyncLink(payload.generateUrl, payload.args).pipe(
            mergeMap(data => {
                const pollObservable = Observable.timer(0, POLL_INTERVAL_MS).pipe(
                    exhaustMap(() => RESTClient.getAuthenticatedObservable(data.url.replace('/api/', ''))),
                    share(),
                );

                const setGenerationIdObservable = Observable.of(data).pipe(
                    map(data => Actions.setAsyncLinkGenerationId.action(payload.identifier, data.generationId)),
                    take(1),
                );

                const updateObservable = pollObservable.pipe(
                    takeWhile(data => !data.download),
                    take(MAX_POLL_ATTEMPTS),
                    map(data => Actions.generateAsyncLinkUpdate.action(payload.identifier, data.complete)),
                );

                const successObservable = pollObservable.pipe(
                    skipWhile(data => !data.download),
                    map(data => Actions.generateAsyncLinkSuccess.action(payload.identifier, data.download)),
                    take(1),
                );

                return Observable.merge(setGenerationIdObservable, updateObservable, successObservable);
            }),
            catchError(e => Observable.of(Actions.generateAsyncLinkFailed.action(e, payload.identifier))),
        ),
    );

export default combineEpics(generateAsyncLink);
